"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocxReportTemplateTableColumnPropertyMapping = exports.PaymentInKindNoticeDocxTemplateTableColumnProperties = exports.DisbursementNoticeDocxTemplateTableColumnProperties = exports.InvoiceDocxTemplateTableColumnProperties = exports.AssetVerificationDocxTemplateTableColumnProperties = exports.ReceivablesSaleAgreementDocxTemplateTableColumnProperties = exports.FundingRequestDocxTemplateTableColumnProperties = exports.DocxReportTemplatePropertyMapping = exports.PaymentInKindNoticeDocxTemplateProperties = exports.DisbursementNoticeDocxTemplateProperties = exports.InvoiceDocxTemplateProperties = exports.AssetVerificationDocxTemplateProperties = exports.ReceivablesSaleAgreementDocxTemplateProperties = exports.FundingRequestDocxTemplateProperties = exports.DocxTemplate = exports.ReportXlsxTemplate = exports.ReportV2 = exports.UploadDownstreamProcess = exports.reportTemplateType = exports.XlsxReportTemplateType = exports.DocxReportTemplateType = exports.ReportTypeIterable = void 0;
const DbTables_1 = require("./DbTables");
exports.ReportTypeIterable = [
    'placeholderReportType',
    'responseTape',
    'extendedResponseTape',
    'newlyAssignedExtendedResponseTape',
    'rawAssignedLoanTape',
    'cashBalancesFeed',
    'monthlyServicerReport',
    'servicerReport',
    'servicerReportPdf',
    'borrowingBaseCertificate',
    'borrowerSubmittedServicerReport',
    'noticeOfBorrowing',
    'releaseNotice',
    'noticeOfPrepayment',
    'receivablesSaleAgreement',
];
var DocxReportTemplateType;
(function (DocxReportTemplateType) {
    DocxReportTemplateType["assetVerification"] = "assetVerification";
    DocxReportTemplateType["borrowingBaseCertificate"] = "borrowingBaseCertificate";
    DocxReportTemplateType["fundingNotice"] = "fundingNotice";
    DocxReportTemplateType["noticeOfBorrowing"] = "noticeOfBorrowing";
    DocxReportTemplateType["noticeOfPrepayment"] = "noticeOfPrepayment";
    DocxReportTemplateType["releaseNotice"] = "releaseNotice";
    DocxReportTemplateType["receivablesSaleAgreement"] = "receivablesSaleAgreement";
    DocxReportTemplateType["invoice"] = "invoice";
    DocxReportTemplateType["disbursementNotice"] = "disbursementNotice";
    DocxReportTemplateType["paymentInKindNotice"] = "paymentInKindNotice";
})(DocxReportTemplateType = exports.DocxReportTemplateType || (exports.DocxReportTemplateType = {}));
var XlsxReportTemplateType;
(function (XlsxReportTemplateType) {
    XlsxReportTemplateType["borrowingBaseServicerReport"] = "borrowingBaseServicerReport";
    XlsxReportTemplateType["fundingRequestServicerReport"] = "fundingRequestServicerReport";
    XlsxReportTemplateType["receivableResponseTapePreviewServicerReport"] = "receivableResponseTapePreviewServicerReport";
    XlsxReportTemplateType["servicerReport"] = "servicerReport";
    XlsxReportTemplateType["monthlyServicerReport"] = "monthlyServicerReport";
})(XlsxReportTemplateType = exports.XlsxReportTemplateType || (exports.XlsxReportTemplateType = {}));
exports.reportTemplateType = {
    ...DocxReportTemplateType,
    ...XlsxReportTemplateType,
};
var UploadDownstreamProcess;
(function (UploadDownstreamProcess) {
    UploadDownstreamProcess["FinancialCovenant"] = "financialCovenant";
})(UploadDownstreamProcess = exports.UploadDownstreamProcess || (exports.UploadDownstreamProcess = {}));
var ReportV2;
(function (ReportV2) {
    ReportV2.ReportTypeIterable = [
        'borrowerSubmittedServicerReport',
        'extendedResponseTape',
        'newlyAssignedExtendedResponseTape',
        'rawAssignedLoanTape',
        'responseTape',
        'servicerReport',
        ...DbTables_1.AssignedLoanTapeReportTypeIterable,
        ...DbTables_1.BorrowingBaseServicerReportTypeIterable,
        ...DbTables_1.ComplianceReportCfTypeIterable,
        ...DbTables_1.CreditFacilityReportTypeIterable,
        ...DbTables_1.FundingRequestReportTypeIterable,
        ...DbTables_1.InvoiceReportTypeIterable,
        ...DbTables_1.LenderShareReportTypeIterable,
        ...DbTables_1.ReceivableResponseTapePreviewReportTypeIterable,
    ];
    ReportV2.EntityNamespaceIterable = [
        'assigned_loan_tapes',
        'borrowing_base_reports',
        'credit_facility_lender_shares',
        'funding_requests',
        'invoices',
        'invoice_payment_in_kind_items',
        'receivable_response_tape_previews',
    ];
})(ReportV2 = exports.ReportV2 || (exports.ReportV2 = {}));
var ReportXlsxTemplate;
(function (ReportXlsxTemplate) {
    let ServicerReportProperty;
    (function (ServicerReportProperty) {
        ServicerReportProperty["reportingDate"] = "reportingDate";
        ServicerReportProperty["currentDate"] = "currentDate";
        ServicerReportProperty["fundingRequestDate"] = "fundingRequestDate";
        ServicerReportProperty["settlementDate"] = "settlementDate";
        ServicerReportProperty["collectionsRecycleTotalAmount"] = "collectionsRecycleTotalAmount";
        ServicerReportProperty["collectionsPaydownTotalAmount"] = "collectionsPaydownTotalAmount";
        ServicerReportProperty["drawRequestTotalAmount"] = "drawRequestTotalAmount";
        ServicerReportProperty["borrowingBaseReserveAmount"] = "borrowingBaseReserveAmount";
        ServicerReportProperty["curePaydownTotalAmount"] = "curePaydownTotalAmount";
        ServicerReportProperty["collectionsRecycleTargetFundingDate"] = "collectionsRecycleTargetFundingDate";
        ServicerReportProperty["collectionsPaydownTargetFundingDate"] = "collectionsPaydownTargetFundingDate";
        ServicerReportProperty["drawRequestTargetFundingDate"] = "drawRequestTargetFundingDate";
        ServicerReportProperty["curePaydownTargetFundingDate"] = "curePaydownTargetFundingDate";
        ServicerReportProperty["currentPrincipalBalance"] = "currentPrincipalBalance";
        ServicerReportProperty["collectionsCashBalance"] = "collectionsCashBalance";
        ServicerReportProperty["preFundingCashBalance"] = "preFundingCashBalance";
        ServicerReportProperty["cashReserveAmount"] = "cashReserveAmount";
        ServicerReportProperty["otherReserveCashBalance"] = "otherReserveCashBalance";
        ServicerReportProperty["permittedInvestmentsCashBalance"] = "permittedInvestmentsCashBalance";
    })(ServicerReportProperty = ReportXlsxTemplate.ServicerReportProperty || (ReportXlsxTemplate.ServicerReportProperty = {}));
    let LoanProductDataTape;
    (function (LoanProductDataTape) {
        LoanProductDataTape["rawAssignedLoanTape"] = "rawAssignedLoanTape";
        LoanProductDataTape["rawCovenantLoanTape"] = "rawCovenantLoanTape";
        LoanProductDataTape["rawMasterLoanTape"] = "rawMasterLoanTape";
        LoanProductDataTape["generatedAssignedLoanTape"] = "generatedAssignedLoanTape";
        LoanProductDataTape["generatedCovenantLoanTape"] = "generatedCovenantLoanTape";
        LoanProductDataTape["generatedMasterLoanTape"] = "generatedMasterLoanTape";
        LoanProductDataTape["responseTape"] = "responseTape";
        LoanProductDataTape["extendedResponseTape"] = "extendedResponseTape";
        LoanProductDataTape["newlyAssignedExtendedResponseTape"] = "newlyAssignedExtendedResponseTape";
        LoanProductDataTape["repaymentTape"] = "repaymentTape";
    })(LoanProductDataTape = ReportXlsxTemplate.LoanProductDataTape || (ReportXlsxTemplate.LoanProductDataTape = {}));
    let OtherDataTape;
    (function (OtherDataTape) {
        OtherDataTape["borrowingBaseReserve"] = "borrowingBaseReserve";
    })(OtherDataTape = ReportXlsxTemplate.OtherDataTape || (ReportXlsxTemplate.OtherDataTape = {}));
    ReportXlsxTemplate.dataTape = {
        ...LoanProductDataTape,
        ...OtherDataTape,
    };
    ReportXlsxTemplate.xlsxTemplateProperty = {
        ...ServicerReportProperty,
        ...LoanProductDataTape,
        ...OtherDataTape,
    };
})(ReportXlsxTemplate = exports.ReportXlsxTemplate || (exports.ReportXlsxTemplate = {}));
var DocxTemplate;
(function (DocxTemplate) {
    let PropertyType;
    (function (PropertyType) {
        PropertyType["CURRENCY"] = "CURRENCY";
        PropertyType["PERCENTAGE"] = "PERCENTAGE";
        PropertyType["DATE"] = "DATE";
        PropertyType["TEXT"] = "TEXT";
        PropertyType["OTHER"] = "OTHER";
    })(PropertyType = DocxTemplate.PropertyType || (DocxTemplate.PropertyType = {}));
    let DocxTemplateProperties;
    (function (DocxTemplateProperties) {
        DocxTemplateProperties["borrowingBaseAmount"] = "borrowingBaseAmount";
        DocxTemplateProperties["borrowingBaseReserveAmount"] = "borrowingBaseReserveAmount";
        DocxTemplateProperties["cashReserveAmount"] = "cashReserveAmount";
        DocxTemplateProperties["collectionsRecycleAmount"] = "collectionsRecycleAmount";
        DocxTemplateProperties["commitmentAmount"] = "commitmentAmount";
        // corresponds to drawRequestAmount seen in templates
        DocxTemplateProperties["drawRequestTotalAmount"] = "drawRequestTotalAmount";
        DocxTemplateProperties["remainingCollectionsAmount"] = "remainingCollectionsAmount";
        DocxTemplateProperties["drawRequestComponentAmountByCapitalProvider"] = "drawRequestComponentAmountByCapitalProvider";
        DocxTemplateProperties["currentPrincipalBalance"] = "currentPrincipalBalance";
        DocxTemplateProperties["totalMaxAdvanceAmount"] = "totalMaxAdvanceAmount";
        DocxTemplateProperties["prepaymentAmount"] = "prepaymentAmount";
        DocxTemplateProperties["newlyAssignedTotalExposure"] = "newlyAssignedTotalExposure";
        DocxTemplateProperties["currentDate"] = "currentDate";
        DocxTemplateProperties["cutoffDate"] = "cutoffDate";
        DocxTemplateProperties["collectionsRecycleTargetFundingDate"] = "collectionsRecycleTargetFundingDate";
        DocxTemplateProperties["drawRequestTargetFundingDate"] = "drawRequestTargetFundingDate";
        DocxTemplateProperties["prepaymentDate"] = "prepaymentDate";
        DocxTemplateProperties["purchaseDate"] = "purchaseDate";
        DocxTemplateProperties["reportingDate"] = "reportingDate";
        DocxTemplateProperties["fundingRequestNumber"] = "fundingRequestNumber";
        DocxTemplateProperties["wiringInstructionsAccountName"] = "wiringInstructionsAccountName";
        DocxTemplateProperties["wiringInstructionsAccountNumber"] = "wiringInstructionsAccountNumber";
        DocxTemplateProperties["wiringInstructionsInstitutionName"] = "wiringInstructionsInstitutionName";
        DocxTemplateProperties["wiringInstructionsRoutingNumber"] = "wiringInstructionsRoutingNumber";
        DocxTemplateProperties["initialFundingRequestNumber"] = "initialFundingRequestNumber";
    })(DocxTemplateProperties = DocxTemplate.DocxTemplateProperties || (DocxTemplate.DocxTemplateProperties = {}));
    DocxTemplate.PropertyTypeMapping = {
        borrowingBaseAmount: PropertyType.CURRENCY,
        borrowingBaseReserveAmount: PropertyType.CURRENCY,
        cashReserveAmount: PropertyType.CURRENCY,
        collectionsRecycleAmount: PropertyType.CURRENCY,
        commitmentAmount: PropertyType.CURRENCY,
        drawRequestTotalAmount: PropertyType.CURRENCY,
        drawRequestComponentAmountByCapitalProvider: PropertyType.CURRENCY,
        remainingCollectionsAmount: PropertyType.CURRENCY,
        currentPrincipalBalance: PropertyType.CURRENCY,
        totalMaxAdvanceAmount: PropertyType.CURRENCY,
        prepaymentAmount: PropertyType.CURRENCY,
        newlyAssignedTotalExposure: PropertyType.CURRENCY,
        currentDate: PropertyType.DATE,
        cutoffDate: PropertyType.DATE,
        collectionsRecycleTargetFundingDate: PropertyType.DATE,
        drawRequestTargetFundingDate: PropertyType.DATE,
        prepaymentDate: PropertyType.DATE,
        purchaseDate: PropertyType.DATE,
        reportingDate: PropertyType.DATE,
        fundingRequestNumber: PropertyType.TEXT,
        wiringInstructionsAccountName: PropertyType.TEXT,
        wiringInstructionsAccountNumber: PropertyType.TEXT,
        wiringInstructionsInstitutionName: PropertyType.TEXT,
        wiringInstructionsRoutingNumber: PropertyType.TEXT,
        initialFundingRequestNumber: PropertyType.OTHER,
    };
    DocxTemplate.CurrencyProperties = [
        DocxTemplateProperties.borrowingBaseAmount,
        DocxTemplateProperties.borrowingBaseReserveAmount,
        DocxTemplateProperties.cashReserveAmount,
        DocxTemplateProperties.collectionsRecycleAmount,
        DocxTemplateProperties.commitmentAmount,
        DocxTemplateProperties.drawRequestTotalAmount,
        DocxTemplateProperties.remainingCollectionsAmount,
        DocxTemplateProperties.drawRequestComponentAmountByCapitalProvider,
        DocxTemplateProperties.currentPrincipalBalance,
        DocxTemplateProperties.totalMaxAdvanceAmount,
        DocxTemplateProperties.prepaymentAmount,
        DocxTemplateProperties.newlyAssignedTotalExposure,
    ];
    DocxTemplate.PercentageProperties = [];
    DocxTemplate.DateProperties = [
        DocxTemplateProperties.currentDate,
        DocxTemplateProperties.cutoffDate,
        DocxTemplateProperties.collectionsRecycleTargetFundingDate,
        DocxTemplateProperties.drawRequestTargetFundingDate,
        DocxTemplateProperties.prepaymentDate,
        DocxTemplateProperties.purchaseDate,
        DocxTemplateProperties.reportingDate,
    ];
    DocxTemplate.TextProperties = [
        DocxTemplateProperties.fundingRequestNumber,
        DocxTemplateProperties.wiringInstructionsAccountName,
        DocxTemplateProperties.wiringInstructionsAccountNumber,
        DocxTemplateProperties.wiringInstructionsInstitutionName,
        DocxTemplateProperties.wiringInstructionsRoutingNumber,
    ];
    DocxTemplate.OtherProperties = [
        DocxTemplateProperties.initialFundingRequestNumber,
    ];
    let DocxTemplateTableColumnProperties;
    (function (DocxTemplateTableColumnProperties) {
        DocxTemplateTableColumnProperties["finleyReceivableId"] = "finleyReceivableId";
        DocxTemplateTableColumnProperties["externalReceivableId"] = "externalReceivableId";
        DocxTemplateTableColumnProperties["purchasePrice"] = "purchasePrice";
        DocxTemplateTableColumnProperties["purchasePercentageRate"] = "purchasePercentageRate";
        DocxTemplateTableColumnProperties["exposure"] = "exposure";
        DocxTemplateTableColumnProperties["agreementCreationDate"] = "agreementCreationDate";
    })(DocxTemplateTableColumnProperties = DocxTemplate.DocxTemplateTableColumnProperties || (DocxTemplate.DocxTemplateTableColumnProperties = {}));
    DocxTemplate.TableColumnPropertyTypeMapping = {
        purchasePrice: PropertyType.CURRENCY,
        purchasePercentageRate: PropertyType.PERCENTAGE,
        exposure: PropertyType.CURRENCY,
        finleyReceivableId: PropertyType.OTHER,
        externalReceivableId: PropertyType.OTHER,
        agreementCreationDate: PropertyType.DATE,
    };
    DocxTemplate.CurrencyTableColumnProperties = [
        DocxTemplateTableColumnProperties.purchasePrice,
        DocxTemplateTableColumnProperties.exposure,
    ];
    DocxTemplate.PercentageTableColumnProperties = [
        DocxTemplateTableColumnProperties.purchasePercentageRate,
    ];
    DocxTemplate.DateTableColumnProperties = [
        DocxTemplateTableColumnProperties.agreementCreationDate,
    ];
    DocxTemplate.TextTableColumnProperties = [
        DocxTemplateTableColumnProperties.finleyReceivableId,
        DocxTemplateTableColumnProperties.externalReceivableId,
    ];
    DocxTemplate.OtherTableColumnProperties = [];
})(DocxTemplate = exports.DocxTemplate || (exports.DocxTemplate = {}));
exports.FundingRequestDocxTemplateProperties = [
    DocxTemplate.DocxTemplateProperties.borrowingBaseAmount,
    DocxTemplate.DocxTemplateProperties.borrowingBaseReserveAmount,
    DocxTemplate.DocxTemplateProperties.cashReserveAmount,
    DocxTemplate.DocxTemplateProperties.collectionsRecycleAmount,
    DocxTemplate.DocxTemplateProperties.commitmentAmount,
    DocxTemplate.DocxTemplateProperties.drawRequestTotalAmount,
    DocxTemplate.DocxTemplateProperties.remainingCollectionsAmount,
    DocxTemplate.DocxTemplateProperties
        .drawRequestComponentAmountByCapitalProvider,
    DocxTemplate.DocxTemplateProperties.currentPrincipalBalance,
    DocxTemplate.DocxTemplateProperties.totalMaxAdvanceAmount,
    DocxTemplate.DocxTemplateProperties.prepaymentAmount,
    DocxTemplate.DocxTemplateProperties.currentDate,
    DocxTemplate.DocxTemplateProperties.collectionsRecycleTargetFundingDate,
    DocxTemplate.DocxTemplateProperties.drawRequestTargetFundingDate,
    DocxTemplate.DocxTemplateProperties.prepaymentDate,
    DocxTemplate.DocxTemplateProperties.fundingRequestNumber,
    DocxTemplate.DocxTemplateProperties.wiringInstructionsAccountName,
    DocxTemplate.DocxTemplateProperties.wiringInstructionsAccountNumber,
    DocxTemplate.DocxTemplateProperties.wiringInstructionsInstitutionName,
    DocxTemplate.DocxTemplateProperties.wiringInstructionsRoutingNumber,
    DocxTemplate.DocxTemplateProperties.initialFundingRequestNumber,
];
exports.ReceivablesSaleAgreementDocxTemplateProperties = [
    DocxTemplate.DocxTemplateProperties.currentDate,
    DocxTemplate.DocxTemplateProperties.cutoffDate,
    DocxTemplate.DocxTemplateProperties.reportingDate,
    DocxTemplate.DocxTemplateProperties.purchaseDate,
    DocxTemplate.DocxTemplateProperties.newlyAssignedTotalExposure,
];
// DocxTemplateProperties are being deprecated. This is here to adhere to the old types while deprecation is ongoing.
exports.AssetVerificationDocxTemplateProperties = [];
exports.InvoiceDocxTemplateProperties = [];
exports.DisbursementNoticeDocxTemplateProperties = [];
exports.PaymentInKindNoticeDocxTemplateProperties = [];
exports.DocxReportTemplatePropertyMapping = {
    [DocxReportTemplateType.assetVerification]: exports.AssetVerificationDocxTemplateProperties,
    [DocxReportTemplateType.receivablesSaleAgreement]: exports.ReceivablesSaleAgreementDocxTemplateProperties,
    [DocxReportTemplateType.borrowingBaseCertificate]: exports.FundingRequestDocxTemplateProperties,
    [DocxReportTemplateType.noticeOfBorrowing]: exports.FundingRequestDocxTemplateProperties,
    [DocxReportTemplateType.releaseNotice]: exports.FundingRequestDocxTemplateProperties,
    [DocxReportTemplateType.noticeOfPrepayment]: exports.FundingRequestDocxTemplateProperties,
    [DocxReportTemplateType.fundingNotice]: exports.FundingRequestDocxTemplateProperties,
    [DocxReportTemplateType.invoice]: exports.InvoiceDocxTemplateProperties,
    [DocxReportTemplateType.disbursementNotice]: exports.DisbursementNoticeDocxTemplateProperties,
    [DocxReportTemplateType.paymentInKindNotice]: exports.PaymentInKindNoticeDocxTemplateProperties,
};
exports.FundingRequestDocxTemplateTableColumnProperties = [];
exports.ReceivablesSaleAgreementDocxTemplateTableColumnProperties = [
    DocxTemplate.DocxTemplateTableColumnProperties.finleyReceivableId,
    DocxTemplate.DocxTemplateTableColumnProperties.externalReceivableId,
    DocxTemplate.DocxTemplateTableColumnProperties.purchasePrice,
    DocxTemplate.DocxTemplateTableColumnProperties.exposure,
    DocxTemplate.DocxTemplateTableColumnProperties.purchasePercentageRate,
    DocxTemplate.DocxTemplateTableColumnProperties.agreementCreationDate,
];
// DocxTemplateProperties are being deprecated. This is here to adhere to the old types while deprecation is ongoing.
exports.AssetVerificationDocxTemplateTableColumnProperties = [];
exports.InvoiceDocxTemplateTableColumnProperties = [];
exports.DisbursementNoticeDocxTemplateTableColumnProperties = [];
exports.PaymentInKindNoticeDocxTemplateTableColumnProperties = [];
exports.DocxReportTemplateTableColumnPropertyMapping = {
    [DocxReportTemplateType.assetVerification]: exports.AssetVerificationDocxTemplateTableColumnProperties,
    [DocxReportTemplateType.receivablesSaleAgreement]: exports.ReceivablesSaleAgreementDocxTemplateTableColumnProperties,
    [DocxReportTemplateType.borrowingBaseCertificate]: exports.FundingRequestDocxTemplateTableColumnProperties,
    [DocxReportTemplateType.noticeOfBorrowing]: exports.FundingRequestDocxTemplateTableColumnProperties,
    [DocxReportTemplateType.releaseNotice]: exports.FundingRequestDocxTemplateTableColumnProperties,
    [DocxReportTemplateType.noticeOfPrepayment]: exports.FundingRequestDocxTemplateTableColumnProperties,
    [DocxReportTemplateType.fundingNotice]: exports.FundingRequestDocxTemplateTableColumnProperties,
    [DocxReportTemplateType.invoice]: exports.InvoiceDocxTemplateTableColumnProperties,
    [DocxReportTemplateType.disbursementNotice]: exports.DisbursementNoticeDocxTemplateTableColumnProperties,
    [DocxReportTemplateType.paymentInKindNotice]: exports.PaymentInKindNoticeDocxTemplateTableColumnProperties,
};
//# sourceMappingURL=Report.js.map